export enum LoadStatusId {
  Pending = 1,
  InTransit = 2,
  Delivered = 3,
  Issue = 4,
  Removed = 5,
  Booked = 6,
}
